import { useMemo } from 'react'
import { getActionPersonName, getActionSubActions, sortActionsByTimestamp } from '@fs/zion-sls'

/**
 * Custom hook to manage deleted persons data and processing
 * @param {Object} currentImage - The current image object
 * @param {boolean} loading - Whether data is loading
 * @param {Object} i18n - Internationalization object
 * @returns {Array} Array of deleted person actions
 */
export const useDeletedPersons = (currentImage, loading, i18n) => {
  const deletedPersonActions = useMemo(() => {
    if (loading || !currentImage?.actions) return []

    // Filter out any persons that have been deleted that haven't been undeleted
    const undoActions = currentImage.actions.filter((a) => a.opCode === 'OP_UNDO')
    const deletedActions = currentImage.actions.filter(
      (a) =>
        a.opCode === 'REMOVE_ELEMENT' &&
        a.elementType === 'PERSON' &&
        !undoActions.find((ua) => ua.stringArg === a.actionId)
    )

    // Sort by timestamp
    sortActionsByTimestamp(deletedActions)

    // Process each deleted person action
    if (deletedActions) {
      deletedActions.forEach((dp) => {
        dp.name = getActionPersonName(currentImage.actions, dp.id, i18n)
        dp.subElements = getActionSubActions(currentImage.actions, dp.id, i18n)
      })
    }

    return deletedActions || []
  }, [currentImage?.actions, loading, i18n])

  return deletedPersonActions
}
